import { useMemo } from 'react';
import { EMPTY_CHAR, DEFAULT_TEST_ID } from './constants.js';
import { Container, Line, Char } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const MonoAddressBlock = ({
  value,
  lineCount = 2,
  prefixCount = 6,
  postfixCount = 4,
  size = 'sm',
  style,
  charStyle,
  prefixStyle,
  postfixStyle,
  className,
  'data-testid': dataTestId = DEFAULT_TEST_ID
}) => {
  const tokens = useMemo(() => {
    const base = value.split('').map((c, idx, arr) => ({
      char: c,
      isPrefix: idx < prefixCount,
      isPostfix: idx >= arr.length - postfixCount
    }));
    if (prefixCount > 0 && prefixCount < base.length) {
      base.splice(prefixCount, 0, {
        char: EMPTY_CHAR,
        isPrefix: false,
        isPostfix: false
      });
    }
    if (postfixCount > 0 && base.length - postfixCount >= 0) {
      const insertPos = base.length - postfixCount;
      base.splice(insertPos, 0, {
        char: EMPTY_CHAR,
        isPrefix: false,
        isPostfix: false
      });
    }
    return base;
  }, [value, prefixCount, postfixCount]);
  const totalChars = tokens.length;
  const perLine = Math.ceil(totalChars / Math.max(1, lineCount));
  const lines = useMemo(() => {
    const out = [];
    for (let i = 0; i < tokens.length; i += perLine) {
      out.push(tokens.slice(i, i + perLine));
    }
    return out;
  }, [tokens, perLine]);
  const renderLine = (line, lineIndex) => jsx(Line, {
    typeSet: size,
    children: line.map((token, idx) => {
      const isHighlighted = token.isPrefix || token.isPostfix;
      const combinedStyle = {
        ...charStyle,
        ...(token.isPrefix && prefixStyle),
        ...(token.isPostfix && postfixStyle)
      };
      return jsx(Char, {
        isHighlighted: isHighlighted,
        style: combinedStyle,
        children: token.char
      }, idx);
    })
  }, lineIndex);
  return jsx(Container, {
    "data-testid": dataTestId,
    style: style,
    className: className,
    children: lines.map(renderLine)
  });
};

export { MonoAddressBlock };
